export default "__VITE_ASSET__DqhrGwJL__"